import {ICustomersQuery} from "../interface/customer";
import {HttpService} from "./http";

export const AppService = {
    getStatuses: () => HttpService.get('/api/app/order/status'),
    getConductionMethods: () => HttpService.get('/api/app/conduction-methods?fromPublish=false'),
    getCategoriesTree: () => HttpService.get('/api/app/categoriesTree'),
    getCategories: () => HttpService.get('/api/app/categories'),
    getCustomers: (params: ICustomersQuery) => HttpService.get('/api/app/customers', params),
}